<template>
    <div class="beibeile">
        <div>
            <img class="messageImg" src="../assets/info_detail/index_detail.png" width="100%" />
            <img class="messageImg" src="../assets/info_detail/bbl_i1.png" width="100%" />
            <img class="messageImg" src="../assets/info_detail/bbl_i2.png" width="100%"/>
            <img class="messageImg" src="../assets/info_detail/bbl_i3.png" width="100%"/>
            <img class="messageImg" src="../assets/info_detail/bbl_i4.png" width="100%"/>
            <div class="botItem">
                <img width="100%" src="../assets/shopStore.png" alt="">
                <div style="text-align:center;margin-top:10px;">护眼天使商城（扫码购买）</div>
            </div>
        </div>
        
        <!-- <div class="btns" @click="showWechatMINI">立即购买</div> -->
    </div>
</template>

<script>
    export default {
        name:'bbl',
        data() {
            return {
            }
        },
        methods: {
            // showWechatMINI() {
            //     window.location.href = 'weixin://dl/business/?t=MSYkNdYrOPq'
            // }
        }
    }
</script>

<style>
    .beibeile {
        width: 50%;
        margin: 0 auto;
    }
    .botItem{
        width: 140px;
        box-shadow: #fff;
        position: fixed;
        left: 76%;
        bottom: 10px;
    }
    @media (max-width: 1024px) {
        .beibeile {
            width: 100%;
            margin: 0 auto;
        }
        .botItem{
            width: 100px;
            box-shadow: #fff;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 100px;
        }
    }
    .btns{
        width: 100%;
        height: 12.6vw;
        background-color: #fff;
    }
    .btns{
        position: fixed;
        bottom: 0;
        left:0;
        background-color: rgb(41,204,208);
        border: none;
        color: #fff;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        width: 100vw;
        height: 12.6vw;
        line-height: 12.6vw;
        font-size:5vw;
        -webkit-tap-highlight-color: rgba(0,0,0,0.08);
        outline:none;
    }
    
</style>